export const getUsuarioById = (usuarios, usuarioId) => {
  const usuario = Array.isArray(usuarios)
        && usuarios.find(usuario => usuario.id === usuarioId);
    return usuario;
};

export const setUsuarioToEdit = (usuarios, usuario) => {
    const usuarioFound = Array.isArray(usuarios) && usuario;
  const usuarioToEdit = {
    ...usuarioFound,
    email: usuario.email,
    user: usuario.user,
    rol: usuario.rol,
    id_academia: usuario.id_academia,
    id_academia_priv: usuario.id_academia_priv,
    contrasena: usuario.contrasena,
    desactivado: !!usuario.desactivado,
    fecha_desactivacion: usuario.fecha_desactivacion || null,
    nombreAcademiaPublica: usuario.nombreAcademiaPublica,
    nombreAcademiaPrivada: usuario.nombreAcademiaPrivada,
  }
  return usuarioToEdit;
};
